// Compose
import { compose } from 'recompose'

// Component pieces
import renderer from './renderer'

const PosterModalRenderer = compose()(renderer)

export default PosterModalRenderer
